import React from 'react';
import { addPopupAction } from 'js/components/common/PopupManager';
import { BonusWithGamesPopup } from '../BonusWithGamesPopup';
import { I18n } from 'js/components/common/I18n';

export const showFreeSpinsBonusPopupAction = (data) => {
    const { freeSpinsCountRemaining } = data.rawBonusDetails.bonus;
    const tKey = 'playtech.mobile.system.freespin-popup.description';

    const useDescription = () => <I18n tKey={tKey} replacers={[freeSpinsCountRemaining]} />;

    return addPopupAction({
        ...data,
        useDescription,
        component: BonusWithGamesPopup
    });
};
